import { render } from "./BlocksSearch.vue?vue&type=template&id=c0507c5c&scoped=true"
import script from "./BlocksSearch.vue?vue&type=script&lang=js"
export * from "./BlocksSearch.vue?vue&type=script&lang=js"

import "./BlocksSearch.vue?vue&type=style&index=0&id=c0507c5c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c0507c5c"

export default script